// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"51b20bab","598":"2506284e","615":"0107e897"}[chunkId] + ".chunk.js";
};